module.exports = __webpack_public_path__ + "static/media/nodata.8f67e337.svg";